import memoize from 'moize';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var ActionName;
(function (ActionName) {
    ActionName["CREATE_ITEM"] = "CREATE_RESOURCE_ITEM";
    ActionName["UPDATE_ITEM"] = "UPDATE_RESOURCE_ITEM";
    ActionName["MODIFY_ITEM"] = "MODIFY_RESOURCE_ITEM";
    ActionName["DELETE_ITEM"] = "DELETE_RESOURCE_ITEM";
    ActionName["GET_ITEMS"] = "GET_RESOURCE_ITEMS";
    ActionName["GET_ITEM"] = "GET_RESOURCE_ITEM";
    ActionName["SET_SELECTED_ITEM"] = "SET_SELECTED_ITEM";
    ActionName["ADD_CREATED_ITEM"] = "ADD_CREATED_ITEM";
    ActionName["SET_UPDATED_ITEM"] = "SET_UPDATED_ITEM";
    ActionName["REMOVE_DELETED_ITEM"] = "REMOVE_DELETED_ITEM";
    ActionName["SET_ITEM_DATA"] = "SET_ITEM_DATA";
    ActionName["CLEAR"] = "CLEAR";
})(ActionName || (ActionName = {}));
var ResourceType;
(function (ResourceType) {
    ResourceType["MULTIPLE_ITEMS"] = "MULTIPLE_ITEMS";
    ResourceType["SINGLE_ITEM"] = "SINGLE_ITEM";
})(ResourceType || (ResourceType = {}));
var LoadingState;
(function (LoadingState) {
    LoadingState["INITIAL"] = "initial";
    LoadingState["LOADING"] = "loading";
    LoadingState["LOADED"] = "loaded";
    LoadingState["ERROR"] = "error";
})(LoadingState || (LoadingState = {}));
var RequestStatus;
(function (RequestStatus) {
    RequestStatus["REQUEST"] = "REQUEST";
    RequestStatus["FAILURE"] = "FAILURE";
    RequestStatus["SUCCESS"] = "SUCCESS";
    RequestStatus["CREATED"] = "CREATED";
    RequestStatus["UPDATED"] = "UPDATED";
    RequestStatus["DELETED"] = "DELETED";
})(RequestStatus || (RequestStatus = {}));

var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["POST"] = "POST";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["DELETE"] = "DELETE";
})(HttpMethod || (HttpMethod = {}));
var splitHeader = function (header, delimiter) {
    if (delimiter === void 0) { delimiter = ';'; }
    return header.split(delimiter).map(function (pair) { return pair.trim(); });
};
var getPairsObject = function (pairs, delimiter) {
    if (delimiter === void 0) { delimiter = '='; }
    var data = {};
    pairs.forEach(function (pair) {
        var _a = pair.split(delimiter), key = _a[0], value = _a[1];
        data[key] = value;
    });
    return data;
};
var jsonHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
var getFormattedActionName = memoize(function (str) {
    return snakeCase(str).toUpperCase();
});
var snakeCase = memoize(function (str) {
    return str
        .replace(/[-\s]+/g, '_')
        .replace(/^_(.+)_$/g, '$1')
        .replace(/([a-z]{1})([A-Z]{1})/g, '$1_$2')
        .toLowerCase();
});
var getAuthHeader = memoize(function (token) {
    if (token === void 0) { token = undefined; }
    return token !== undefined ? { Authorization: "Bearer " + token } : {};
});
var isValidBody = function (method, body) {
    return method.toUpperCase() !== HttpMethod.GET && body !== undefined;
};
var getHeaders = function (headers, authHeader, defaultHeaders) {
    var combinedHeaders = Object.assign({}, defaultHeaders || {}, headers || {}, authHeader || {});
    return new Headers(combinedHeaders);
};
var getMethod = memoize(function (method) {
    method = method.toUpperCase();
    switch (method) {
        case HttpMethod.GET:
        case HttpMethod.PUT:
        case HttpMethod.PATCH:
        case HttpMethod.POST:
        case HttpMethod.DELETE:
            return method;
        default:
            throw new Error('Invalid HTTP Method');
    }
});
var getAPIRequestOptions = memoize(function (method, body, headers, token) {
    if (body === void 0) { body = undefined; }
    if (headers === void 0) { headers = {}; }
    if (token === void 0) { token = undefined; }
    return __assign({ method: getMethod(method), headers: getHeaders(headers, getAuthHeader(token), jsonHeaders) }, (isValidBody(method, body) && { body: JSON.stringify(body) }));
});

var getSimpleReducer = memoize(function (resourceName, resource, defaultState) {
    if (defaultState === void 0) { defaultState = defaultSimpleReducerState; }
    var reducer = function (state, action) {
        if (state === void 0) { state = defaultState; }
        var reducerState = getReducerState(resource.actionName, resourceName);
        switch (action.type) {
            case reducerState:
                return __assign(__assign({}, state), { data: __assign({}, action.data), isSet: true });
            default:
                return state;
        }
    };
    return reducer;
});
var getAPIReducer = memoize(function (resourceName, resource, defaultState) {
    if (defaultState === void 0) { defaultState = defaultAPIReducerState; }
    return resource.type === ResourceType.MULTIPLE_ITEMS
        ? getCombinedReducer(resourceName, resource, defaultState)
        : getAPIRequestStatesReducer(resourceName, resource, defaultState);
});
var getAPIRequestStatesReducer = function (resourceName, resource, defaultState) {
    var reducer = function (state, action) {
        if (state === void 0) { state = defaultState; }
        var transformFn = resource.transforms[0];
        var request = getReducerState(resource.actionName, resourceName, RequestStatus.REQUEST);
        var failure = getReducerState(resource.actionName, resourceName, RequestStatus.FAILURE);
        var success = getReducerState(resource.actionName, resourceName, RequestStatus.SUCCESS);
        var setItemData = getReducerState(ActionName.SET_ITEM_DATA, resourceName);
        var clear = getReducerState(ActionName.CLEAR, resourceName);
        switch (action.type) {
            case request:
                return __assign(__assign({}, state), { isLoading: true, isLoaded: false, isError: false, error: undefined });
            case success:
                return __assign(__assign({}, state), { isLoading: false, isLoaded: true, data: transformFn(action.data), isError: false, error: undefined });
            case setItemData:
                return __assign(__assign({}, state), { isLoading: false, isLoaded: true, data: action.data, isError: false, error: undefined });
            case failure:
                return __assign(__assign({}, state), { isLoaded: false, isLoading: false, isError: true, error: action.data });
            case clear:
                return defaultState;
            default:
                return state;
        }
    };
    return reducer;
};
var getItemListReducer = function (resourceName, resource, defaultState) {
    var reducer = function (state, action) {
        if (state === void 0) { state = defaultState; }
        var created = getReducerState(ActionName.ADD_CREATED_ITEM, resourceName);
        var updated = getReducerState(ActionName.SET_UPDATED_ITEM, resourceName);
        var deleted = getReducerState(ActionName.REMOVE_DELETED_ITEM, resourceName);
        switch (action.type) {
            case created:
                return __assign(__assign({}, state), { data: addCreatedItem(action.data, state.data) });
            case updated:
                return __assign(__assign({}, state), { data: setUpdatedItem(action.data, state.data) });
            case deleted:
                return __assign(__assign({}, state), { data: removeDeletedItem(action.data, state.data) });
            default:
                return state;
        }
    };
    return reducer;
};
var getCombinedReducer = function (resourceName, resource, defaultState) {
    var itemListReducer = getItemListReducer(resourceName, resource, defaultState);
    var apiRequestStatesReducer = getAPIRequestStatesReducer(resourceName, resource, defaultState);
    var combinedReducer = function (state, action) {
        if (state === void 0) { state = defaultState; }
        var newState = apiRequestStatesReducer(state, action);
        newState = itemListReducer(newState, action);
        return newState;
    };
    return combinedReducer;
};
var getReducerKey = memoize(function (resourceName, actionName) {
    return resourceName.toUpperCase() + "." + actionName;
});
var getReducerState = memoize(function (actionName, resourceName, state) {
    if (state === void 0) { state = undefined; }
    var formattedActionName = getFormattedActionName(actionName);
    var reducerState = resourceName.toUpperCase() + "_" + formattedActionName;
    reducerState += state !== undefined ? "_" + state : '';
    return reducerState;
});
var defaultAPIReducerState = {
    data: {},
    isLoading: false,
    isLoaded: false,
    isError: false,
    error: undefined
};
var defaultSimpleReducerState = {
    isSet: false,
    data: {}
};
var addItemToObject = function (item, dataObject) {
    var _a;
    var key = String(item.id);
    return __assign(__assign({}, dataObject), (_a = {}, _a[key] = item, _a));
};
var removeItemFromObject = function (item, dataObject) {
    var key = String(item.id);
    var obj = __assign({}, dataObject);
    delete obj[key];
    return obj;
};
var addCreatedItem = addItemToObject;
var setUpdatedItem = addItemToObject;
var removeDeletedItem = removeItemFromObject;

var getAction = memoize(function (type, data) {
    if (data === void 0) { data = null; }
    return __assign({ type: type }, (data !== null && { data: data }));
});

var transformResponseData = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var json, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, response.json()];
            case 1:
                json = _a.sent();
                return [2 /*return*/, json.data || json || null];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };

var getAPIAction = memoize(function (resourceName, options, resource, body, values, headers) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var endpointURL, apiOptions, response, type, payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // dispatch request status:
                    dispatchStatus(dispatch, resource.actionName, resourceName, RequestStatus.REQUEST);
                    endpointURL = getEndpoint(resource.endpoint || '', options, values);
                    apiOptions = getAPIRequestOptions(resource.method, body, headers, options.token);
                    return [4 /*yield*/, getResponse(endpointURL, apiOptions, resource.defaultData, resource.responseTransformer)];
                case 1:
                    response = _a.sent();
                    type = response.ok ? RequestStatus.SUCCESS : RequestStatus.FAILURE;
                    payload = response.ok ? response.data : response.statusText;
                    // dispatch success:
                    dispatchStatus(dispatch, resource.actionName, resourceName, type, payload);
                    // return response:
                    return [2 /*return*/, response];
            }
        });
    }); };
});
// find any :prop in endpoint and replace with and prop of same name in options or values:
var getEndpoint = memoize(function (endpoint, options, values) {
    if (values === void 0) { values = undefined; }
    var matches = endpoint.match(/:(\w+)/g);
    if (matches !== null) {
        matches.forEach(function (match) {
            var propName = match.replace(':', '');
            var propValue = values && values[propName] ? values[propName] : options && options[propName] ? options[propName] : match;
            endpoint = endpoint.replace(match, propValue);
        });
    }
    return endpoint;
});
var dispatchStatus = function (dispatch, opName, resourceName, status, data) {
    if (status === void 0) { status = undefined; }
    if (data === void 0) { data = undefined; }
    var requestState = getReducerState(opName, resourceName, status);
    dispatch(getAction(requestState, data));
};
var getResponse = function (endpointURL, apiOptions, defaultData, transformer) { return __awaiter(void 0, void 0, void 0, function () {
    var apiResponse, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getAPIResponse(endpointURL, apiOptions)];
            case 1:
                apiResponse = _a.sent();
                return [4 /*yield*/, getResponseData(apiResponse, defaultData, transformer)];
            case 2:
                data = _a.sent();
                return [2 /*return*/, {
                        ok: apiResponse.ok,
                        status: Number(apiResponse.status),
                        statusText: apiResponse.statusText,
                        error: apiResponse.ok ? undefined : apiResponse.statusText,
                        data: data,
                        response: apiResponse
                    }];
        }
    });
}); };
var getAPIResponse = function (endpointURL, apiOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch(endpointURL, apiOptions)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, new Response(null, { status: 444, statusText: error_1.toString() })];
            case 3: return [2 /*return*/];
        }
    });
}); };
var getResponseData = function (response, defaultData, transformer) {
    if (transformer === void 0) { transformer = transformResponseData; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!response.ok) {
                        return [2 /*return*/, defaultData];
                    }
                    return [4 /*yield*/, transformer(response)];
                case 1: return [2 /*return*/, (_a.sent()) || defaultData];
            }
        });
    });
};

var objKeyValues = memoize(function (data) {
    var obj = {};
    data.forEach(function (item) {
        var key = String(item.id);
        obj[key] = item;
    });
    return obj;
});
var arrObjectValues = memoize(function (data) {
    return Object.values(data);
});
var noTransform = memoize(function (data) { return data; });

var _a;
var getResource = memoize(function (actionName, endpoint, options) {
    if (endpoint === void 0) { endpoint = undefined; }
    if (options === void 0) { options = {}; }
    var formattedActionName = getFormattedActionName(actionName);
    var method = getMethod$1(options.method, actionName);
    var dataName = options.dataName || getDataName(actionName);
    var type = getType(options.type, actionName);
    var defaultData = options.defaultData || getDefaultData(type);
    var transforms = options.transforms || getTransforms(type);
    var isAPIResource = endpoint !== undefined;
    var headers = options.headers || {};
    var responseTransformer = options.responseTransformer || transformResponseData;
    return {
        actionName: formattedActionName,
        endpoint: endpoint,
        method: method,
        transforms: transforms,
        defaultData: defaultData,
        dataName: dataName,
        type: type,
        isAPIResource: isAPIResource,
        headers: headers,
        responseTransformer: responseTransformer
    };
});
var getTransforms = memoize(function (resourceType) {
    return resourceType === ResourceType.MULTIPLE_ITEMS ? [objKeyValues, arrObjectValues] : [noTransform, noTransform];
});
var getDefaultData = memoize(function (resourceType) {
    return resourceType === ResourceType.MULTIPLE_ITEMS ? [] : {};
});
var getDefaultMethod = memoize(function (actionName) {
    switch (actionName) {
        case ActionName.CREATE_ITEM:
            return HttpMethod.POST;
        case ActionName.UPDATE_ITEM:
            return HttpMethod.PUT;
        case ActionName.MODIFY_ITEM:
            return HttpMethod.PATCH;
        case ActionName.DELETE_ITEM:
            return HttpMethod.DELETE;
        case ActionName.GET_ITEMS:
        case ActionName.GET_ITEM:
        default:
            return HttpMethod.GET;
    }
});
var getMethod$1 = memoize(function (method, actionName) {
    try {
        return getMethod(method);
    }
    catch (error) {
        return getDefaultMethod(actionName);
    }
});
var defaultDataNames = (_a = {},
    _a[ActionName.CREATE_ITEM] = 'createdItem',
    _a[ActionName.UPDATE_ITEM] = 'updatedItem',
    _a[ActionName.MODIFY_ITEM] = 'modifiedItem',
    _a[ActionName.DELETE_ITEM] = 'deletedItem',
    _a[ActionName.GET_ITEMS] = 'items',
    _a[ActionName.GET_ITEM] = 'item',
    _a[ActionName.SET_SELECTED_ITEM] = 'selectedItem',
    _a);
var getDataName = memoize(function (actionName) {
    return defaultDataNames[actionName] || actionName;
});
var getType = memoize(function (type, actionName) {
    switch (type) {
        case ResourceType.MULTIPLE_ITEMS:
        case ResourceType.SINGLE_ITEM:
            return type;
    }
    return actionName === ActionName.GET_ITEMS ? ResourceType.MULTIPLE_ITEMS : ResourceType.SINGLE_ITEM;
});

var apiResourceCollection = function (name, options) {
    if (options === void 0) { options = {}; }
    var resourceName = name.toUpperCase();
    var resources = {};
    var reducers = {};
    var addResource = function (resource) {
        resources[resource.actionName] = resource;
        var key = getReducerKey(resourceName, resource.actionName);
        var reducerFn = resource.isAPIResource ? getAPIReducer : getSimpleReducer;
        reducers[key] = reducerFn(resourceName, resource);
    };
    var getReducers = function () {
        return reducers;
    };
    var action = function (actionName, body, values, headers) {
        if (values === void 0) { values = undefined; }
        if (headers === void 0) { headers = undefined; }
        actionName = getFormattedActionName(actionName);
        var resource = resources[actionName];
        return resource.isAPIResource ? apiAction(actionName, body, values, headers) : simpleAction(actionName, body);
    };
    var simpleAction = function (actionName, body) {
        actionName = getFormattedActionName(actionName);
        var reducerState = getReducerState(actionName, resourceName);
        return getAction(reducerState, body);
    };
    var apiAction = function (actionName, body, values, headers) {
        if (values === void 0) { values = {}; }
        if (headers === void 0) { headers = {}; }
        actionName = getFormattedActionName(actionName);
        var resource = resources[actionName];
        headers = Object.assign({}, resource.headers, headers);
        return getAPIAction(resourceName, options, resource, body, values, headers);
    };
    var useCollection = function (state) {
        return getCollection(state, resources, resourceName);
    };
    // COMMON ACTIONS WRAPPERS:
    var setItemData = function (data) {
        return simpleAction(ActionName.SET_ITEM_DATA, data);
    };
    var clear = function () {
        return simpleAction(ActionName.CLEAR, null);
    };
    var setSelectedItem = function (data) {
        return simpleAction(ActionName.SET_SELECTED_ITEM, data);
    };
    var addCreatedItem = function (data) {
        return simpleAction(ActionName.ADD_CREATED_ITEM, data);
    };
    var setUpdatedItem = function (data) {
        return simpleAction(ActionName.SET_UPDATED_ITEM, data);
    };
    var removeDeletedItem = function (data) {
        return simpleAction(ActionName.REMOVE_DELETED_ITEM, data);
    };
    var deleteItem = function (data, values, headers) {
        if (headers === void 0) { headers = {}; }
        return apiAction(ActionName.DELETE_ITEM, data, values, headers);
    };
    var updateItem = function (data, values, headers) {
        if (headers === void 0) { headers = {}; }
        return apiAction(ActionName.UPDATE_ITEM, data, values, headers);
    };
    var modifyItem = function (data, values, headers) {
        if (headers === void 0) { headers = {}; }
        return apiAction(ActionName.MODIFY_ITEM, data, values, headers);
    };
    var createItem = function (data, values, headers) {
        if (headers === void 0) { headers = {}; }
        return apiAction(ActionName.CREATE_ITEM, data, values, headers);
    };
    var getItems = function (data, values, headers) {
        if (headers === void 0) { headers = {}; }
        return apiAction(ActionName.GET_ITEMS, data, values, headers);
    };
    var getItem = function (data, values, headers) {
        if (headers === void 0) { headers = {}; }
        return apiAction(ActionName.GET_ITEM, data, values, headers);
    };
    // add setSelectedItem to resource collection:
    addResource(getResource(ActionName.SET_SELECTED_ITEM));
    return {
        addResource: addResource,
        getReducers: getReducers,
        action: action,
        setSelectedItem: setSelectedItem,
        deleteItem: deleteItem,
        updateItem: updateItem,
        modifyItem: modifyItem,
        createItem: createItem,
        setItemData: setItemData,
        clear: clear,
        getItems: getItems,
        getItem: getItem,
        useCollection: useCollection,
        addCreatedItem: addCreatedItem,
        setUpdatedItem: setUpdatedItem,
        removeDeletedItem: removeDeletedItem
    };
};
var getCollection = memoize(function (state, resources, resourceName) {
    var collection = { isLoading: false };
    Object.values(resources).forEach(function (resource) {
        var key = getReducerKey(resourceName, resource.actionName);
        collection[resource.dataName] = getCollectionState(state[key], resource.transforms[1]);
        collection.isLoading = state[key].isLoading ? true : collection.isLoading;
    });
    return collection;
});
var getLoadingState = memoize(function (isLoading, isLoaded, isError) {
    var loadingStr = Number(Boolean(isLoading)) + "." + Number(Boolean(isLoaded)) + "." + Number(Boolean(isError));
    switch (loadingStr) {
        case '1.0.0':
            return LoadingState.LOADING;
        case '0.1.0':
            return LoadingState.LOADED;
        case '0.0.1':
            return LoadingState.ERROR;
        case '0.0.0':
        default:
            return LoadingState.INITIAL;
    }
});
var getCollectionState = memoize(function (state, transformFn) {
    return __assign(__assign({}, state), { data: transformFn(state.data), loadingState: getLoadingState(state.isLoading, state.isLoaded, state.isError) });
});

export { ActionName, HttpMethod, LoadingState, RequestStatus, ResourceType, addItemToObject, apiResourceCollection, arrObjectValues, defaultAPIReducerState, defaultSimpleReducerState, getAPIRequestOptions, getAction, getAuthHeader, getHeaders, getMethod, getPairsObject, getReducerKey, getReducerState, getResource, getResponse, jsonHeaders, noTransform, objKeyValues, removeItemFromObject, splitHeader, transformResponseData };
